import Http from '../http'

export const index = (page, name) => Http.get(`/recurrences?page=${page}${(name) ? '&name=' + name : ''}`, { headers: { Authorization: localStorage.token } })
export const store = (data) => Http.post('/recurrences', data, { headers: { Authorization: localStorage.token } })
export const update = (data) => Http.patch(`/recurrences/${data.id}`, data, { headers: { Authorization: localStorage.token } })
export const destroy = (id) => Http.delete(`/recurrences/${id}`, { headers: { Authorization: localStorage.token } })
